'use client'

import { Hits } from 'react-instantsearch'

import { AlgoliaProductCard } from '@/components/common/AlgoliaProductCard/AlgoliaProductCard'

export function ProductsList({ collectionHandle, collectionId, listName }: { collectionHandle: string; collectionId: string; listName?: string }) {
  return (
    <div className="relative z-10 mt-8">
      <div className="mx-auto overflow-hidden rounded-2xl bg-white shadow-xl">
        <Hits
          hitComponent={({ hit }) => {
            return <AlgoliaProductCard hit={hit} collectionHandle={collectionHandle} collectionId={collectionId} listName={listName} />
          }}
          classNames={{
            list: `grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4
          [&>*:nth-child(2n)]:border-r-0 sm:[&>*:nth-child(2n)]:border-r-[1px] lg:[&>*:nth-child(2n)]:border-r-[1px]
           sm:[&>*:nth-child(3n)]:border-r-0 lg:[&>*:nth-child(3n)]:border-r-[1px]
           lg:[&>*:nth-child(4n)]:border-r-0 `,
            item: 'border-b border-r border-grey-200 h-full',
          }}
        />
      </div>
    </div>
  )
}
